Object.defineProperty(exports, '__esModule', { value: true });

var kennitala = require('./kennitala-b93e0ded.js');



exports.cleanKennitalaAggressive = kennitala.cleanKennitalaAggressive;
exports.cleanKennitalaCareful = kennitala.cleanKennitalaCareful;
exports.formatKennitala = kennitala.formatKennitala;
exports.generateKennitala = kennitala.generateKennitala;
exports.getKennitalaBirthDate = kennitala.getKennitalaBirthDate;
exports.isCompanyKennitala = kennitala.isCompanyKennitala;
exports.isPersonKennitala = kennitala.isPersonKennitala;
exports.isTempKennitala = kennitala.isTempKennitala;
exports.isValidKennitala = kennitala.isValidKennitala;
exports.parseKennitala = kennitala.parseKennitala;
